module.exports = __webpack_public_path__ + "static/media/IconStreetView.ff6ac8ef.svg";